export default {
  color: {
    title: 'Цвет шрифта и фона',
    type: 'color',
    items: [
      {
        name: 'Обычный',
        classes: ['version_button'],
        value: 'usual',
      },
      {
        name: 'Контрастный',
        classes: ['version_button', 'version_button__contrast'],
        value: 'contrast',
      },
      {
        name: 'Инверсия',
        classes: ['version_button', 'version_button__inversion'],
        value: 'inversion',
      },
      {
        name: 'Комфортный',
        classes: ['version_button', 'version_button__comfort'],
        value: 'comfort',
      },
    ],
  },
  buttons: {
    title: 'Цвет кнопок и ссылок',
    type: 'buttons',
    items: [
      {
        name: 'Обычный',
        classes: ['version_button'],
        value: 'usual',
      },
      {
        name: 'Красный',
        classes: ['version_button', 'version_button__red'],
        value: 'red',
      },
      {
        name: 'Синий',
        classes: ['version_button', 'version_button__blue'],
        value: 'blue',
      },
    ],
  },
  picture: {
    title: 'Изображения',
    type: 'picture',
    items: [
      {
        text: 'Цветные',
        iconClasses: 'version_icon version_icon__picture',
        classes: ['version_button', 'version_button__large'],
        value: 'color',
      },
      {
        text: 'Отключить',
        iconClasses: 'version_icon version_icon__disable',
        classes: ['version_button', 'version_button__large'],
        value: 'disable',
      },
    ],
  },
  font: {
    title: 'Использовать шрифт',
    type: 'font',
    items: [
      {
        text: 'Arial',
        iconClasses: 'version_icon version_icon__arial',
        classes: ['version_button', 'version_button__large'],
        value: 'arial',
      },
      {
        text: 'Times New Roman',
        iconClasses: 'version_icon version_icon__times',
        classes: ['version_button', 'version_button__large'],
        value: 'times',
      },
    ],
  },
};
